import { Injectable } from "@angular/core";
import { EntityState, ID, QueryEntity } from "@datorama/akita";
import { IArticoloPortaleOloFE } from "@common/interfaces/olo";
import { ArticoloPortaleOloStore } from './articoloPortaleOlo.store';

export interface ArticoloPortaleOloState extends EntityState<IArticoloPortaleOloFE, ID>{ };

@Injectable({
    providedIn: 'root'
  })
  export class ArticoloPortaleOloQuery extends QueryEntity<ArticoloPortaleOloState> {
  
    constructor(protected store: ArticoloPortaleOloStore) {
      super(store);
    }
  }
